import { Component, Input, OnInit, ViewChild,SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Currency } from '../user-profile-details/currency';
import { UrlConstants } from 'src/app/models/urlConstants';
import { HttpClient } from '@angular/common/http';
import { Bank, BanksDetails } from "../user-profile-details/bank";
import { Account, ClientData } from 'src/app/screens/user-profile/client-data';
import { SummaryModalComponent } from '../summary-modal/summary-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SignalR } from 'ng2-signalr';
import { RequestService } from 'src/app/services/request.service';
import { ApiService } from 'src/app/services/api.service';
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { MatStepper } from "@angular/material/stepper";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";


enum PaymentMethod {
  BankTransfer = 'bank-transfer',
  //CreditCard = 'credit-card',
  //SmartWallet = 'smart-wallet'
}

export class FileToUpload {
  fileName: string = "";
  fileSize: number = 0;
  fileType: string = "";
  fileAsBase64: string = "";
}

interface Option {
  id: PaymentMethod;
  label: string;
}
interface DepositRequest {
  CurrencyId: number;
  Date: Date;
  RelationCode: string;
  Amount: number;
  DepositeBankId: number;
  file: FileToUpload;
  BankAccountId: number;
}


@Component({
  selector: 'app-request-deposit-modal',
  templateUrl: './request-deposit-modal.component.html',
  styleUrls: ['./request-deposit-modal.component.scss']
})
export class RequestDepositModalComponent implements OnInit {
  selectedMethod: PaymentMethod = PaymentMethod.BankTransfer;
  options: Option[] = [
    //{ id: PaymentMethod.CreditCard, label: 'credit-card' },
    { id: PaymentMethod.BankTransfer, label: 'bank-transfer' },
    //{ id: PaymentMethod.SmartWallet, label: 'smart-wallet' }
  ];
  lang: string = "en";
  swiftcode: string = "";
  accountNumber: string = "";
  iBAN: string = "EGP";
  fileToUpload: File | null = null;
  fileName: string;
  @Input() selectedAccount: Account;
  branches: any[] = [];
  selectedCurrency: Currency | null = null;
  PaymentMethod: any = {};
  currencyList: Currency[] = [];
  banksList: Bank[] = [];
  banksDetailsList: BanksDetails[] = [];
  selectedBranch: BanksDetails;
  depositMethod: PaymentMethod;
  //depositForm: NgForm;
  newDeposit: DepositRequest = {} as DepositRequest;
  selectedBank: Bank;
  today: string = new Date().toISOString().split('T')[0];
  Date: string = this.today;
  BankAccountId: number;
  cashAmount = 0;
  uploadedFiles: File[] = [];
  cashControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d+(\.\d{1,2})?$/)
  ]);
  @ViewChild('depositForm') depositForm: NgForm;
  @ViewChild('stepper') stepper!: MatStepper;

  
 userAccounts :  Account[];
 userPortfolio: ClientData;
 isDarkTheme: boolean;
 isSubmitting: boolean;
 allBanks: any[] = [];
  stepperOrientation: 'horizontal' | 'vertical' = 'horizontal';


  accountList: Account[];

  constructor(
    public translate: TranslateService,
    private http: HttpClient,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private apiService: ApiService,
    private requestService: RequestService,
    private signalR: SignalR,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.stepperOrientation = result.matches ? 'vertical' : 'horizontal';
      });
    this.isDarkTheme = localStorage.getItem("darktheme") == "dark" ? true : false;
    this.depositMethod = PaymentMethod.BankTransfer;
    this.cashAmount = null; // Or set default value if required
    this.lang = localStorage.getItem("lang");
    this.requestService.fetchBanks().subscribe((res) => (this.banksList = res));
    this.requestService.fetchBanksDetails().subscribe((res) => (this.banksDetailsList = res));
    this.requestService.fetchActiveCurrencies().subscribe((res) => {
      this.currencyList = res;
      this.selectedCurrency = null;
    });
    this.cashControl.valueChanges.subscribe((value) => {
      this.handleCashAmountChange(value);
    });
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
  }
    ngOnChanges(changes: SimpleChanges): void {
      if (changes.selectedAccount && changes.selectedAccount.currentValue) {
        this.clientSelected(changes.selectedAccount.currentValue);
        this.fetchUserPortfolio(changes.selectedAccount.currentValue);
      }
    }

onCurrencyChange(currency: Currency | null) {
  this.selectedCurrency = currency || null;

  this.requestService.fetchBanks().subscribe({
    next: (res) => {
      this.allBanks = res; // keep the full list cached

      const hasCurrency = !!currency && Number(currency.CurrencyID) > 0;

      const filtered = hasCurrency
        ? res.filter((bank: any) => Number(bank.CurrencyId) === Number(currency!.CurrencyID))
        : res;

      // Fallback to full list if the filter produced nothing
      const source = (hasCurrency && filtered.length === 0) ? res : filtered;

      // Dedupe by BankID
      const unique = new Map<number, any>();
      source.forEach((bank: any) => {
        const id = Number(bank.BankID);
        if (!Number.isNaN(id) && !unique.has(id)) unique.set(id, bank);
      });

      this.banksList = Array.from(unique.values());
      this.selectedBank = null;
    },
    error: (err) => {
      console.error('fetchActiveBanks failed', err);
      // Graceful degrade: keep previous banksList if you want, or clear it
      // this.banksList = [];
    }
  });

  this.requestService.fetchBanksDetails().subscribe({
    next: (res) => (this.banksDetailsList = res),
    error: (err) => console.error('fetchBanksDetails failed', err),
  });
}

  selectOption(optionId: PaymentMethod) {
    this.selectedMethod = optionId;
    switch (optionId) {
      // case PaymentMethod.SmartWallet:
      //   this.PaymentMethod.ActionType = 1;
      //   break;
      case PaymentMethod.BankTransfer:
        this.PaymentMethod.ActionType = 2;
        break;
      // case PaymentMethod.CreditCard:
      //   this.PaymentMethod.ActionType = 3;
      //   break;
    }

  }

  preventPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  copyText(spanId: string): void {
    const spanElement = document.getElementById(spanId);
    if (spanElement) {
      const textToCopy = spanElement.textContent || '';
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          alert('Copied the text: ' + textToCopy);
        })
        .catch((err) => {
        });
    } else {
    }
  }

  importFile(files: FileList | null) {
    const maxAllowedSize = 5 * 1024 * 1024; // 5MB
    if (files && files.length > 0) {
      const file = files[0]; // Only take the first file
      if (file.size <= maxAllowedSize) {
        this.fileToUpload = file;
        this.fileName = file.name;
        this.uploadedFiles = [file]; // Replace the array with the new file
      } else {
        this.fileName = this.translate.instant("too-big");
        this.fileToUpload = null; // Reset if file is too big
        this.uploadedFiles = [];
      }
    }
  }
  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);
    this.fileToUpload = null;
    this.fileName = '';
    this.uploadedFiles = [];
    
    // Reset the file input
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

GetBranches(event: { BankID: number | string }) {
  const eventBankId = Number(event?.BankID);

  // 1) Find the bank
  const bank = (this.allBanks ?? []).find((b: any) => Number(b.BankID) === eventBankId);

  // 2) Extract branches (default to empty array)
  const branches = Array.isArray(bank?.BankBranches) ? bank.BankBranches : [];

  // 3) Sort or transform if you wish (optional)
  // branches.sort((a: any, b: any) => String(a.BranchName ?? '').localeCompare(String(b.BranchName ?? '')));

  // 4) Update state
  this.branches = branches;
  this.selectedBranch = this.branches.length > 0 ? this.branches[0] : null;

  // 5) Guarded property access
  this.accountNumber = this.selectedBranch?.AccountNo ?? null;
  this.swiftcode     = this.selectedBranch?.SwiftCode ?? null;
  this.iBAN          = this.selectedBranch?.IBAN ?? null;
}

  handleCashAmountChange(value: string): void {
    const filteredValue = value.replace(/[^0-9.]/g, '');

    if (filteredValue !== value) {
      this.cashAmount = parseFloat(filteredValue) || 0;
    }
    const trimmedValue = filteredValue.replace(/^0+(?!.)/, '');
    this.cashAmount = parseFloat(trimmedValue) || 0;

    this.cashControl.setValue(trimmedValue, { emitEvent: false });
  }

  summary(cashAmount: number): void {
    const dialogRef =this.dialog.open(SummaryModalComponent, {
      data: {
        width: '75vw',
        maxWidth: '600px',
        minWidth: '320px',
        titleKey: 'summary-banner-title',
        subtitleKey: 'summary-banner-text',
        details: [
                    { icon: 'mat-person',
              labelKey: 'client', 
              value: this.translate.currentLang === 'en' ? 
              this.selectedAccount.clientNameEn : this.selectedAccount.clientNameAr },
            { icon: "💰", 
              labelKey: "amount", 
              value: cashAmount },
            { icon: '💵',
              labelKey: 'currency', 
              value: this.translate.currentLang === 'en' ? this.selectedCurrency?.AbbreviationE : this.selectedCurrency?.AbbreviationA },
            { icon: '📆',
              labelKey: 'date',
              value: this.today },
            { icon: '🏢', 
              labelKey: 'Deposit_Bank',
              value: this.translate.currentLang === 'en' ? this.selectedBank?.BankNameE : this.selectedBank?.BankNameA },
            { icon: '🏦', 
              labelKey: 'branch', 
              value: this.translate.currentLang === 'en' ? this.selectedBranch?.BranchNameE : this.selectedBranch?.BranchNameA },
            {
              icon: "mat-credit_card",
              labelKey: "swift-code",
              value: this.swiftcode,
            },            {
              icon: "mat-credit_card",
              labelKey: "IBAN",
              value: this.iBAN,
            },
            { icon: "📎", 
              labelKey: "attachment", 
              value: this.fileName },

        ]
      },
      direction: this.translate.currentLang === 'ar' ? 'rtl' : 'ltr'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.isSubmitting = true;
      
        if (this.fileToUpload != null) {
          let file = new FileToUpload();
          file.fileName = this.fileToUpload.name;
          file.fileSize = this.fileToUpload.size;
          file.fileType = this.fileToUpload.type;
      
          let reader = new FileReader();
          reader.onload = () => {
            file.fileAsBase64 = reader.result.toString();
            this.newDeposit.file = file;
            this.submitDeposit();
          };
          reader.readAsDataURL(this.fileToUpload);
        } else {
          this.submitDeposit();
        }
      } else {
      }
    });
  }

  submitDeposit() {
    this.newDeposit.RelationCode = this.selectedAccount.relationCode;
    this.newDeposit.Amount = this.cashAmount;
    this.newDeposit.Date = this.depositForm.value.Date;
    this.newDeposit.CurrencyId = this.selectedCurrency?.CurrencyID;
    this.newDeposit.DepositeBankId = this.depositForm.value.depositBank?.BankID;
    this.newDeposit.BankAccountId = this.depositForm.value.depositBank?.BankAccountId;

    this.http
      .post(
        UrlConstants.backofficeUrl + "/api/OnlineTrading/PostPayableRequest",
        this.newDeposit
      )
      .subscribe(
        (res) => {
          this.isSubmitting = false;
          if (res) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: this.translate.instant("succes-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
            this.router.navigate(['/requests-analysis/requests-table']);
          }
          else
            this.isSubmitting = false;
        },
        (err) => {
          this.isSubmitting = false; // Ensure submission flag is reset
          Swal.fire({
            position: "center",
            icon: "error",
            title: this.translate.instant("error-msg"),
            showConfirmButton: false,
            timer: 4500,
          });
          this.router.navigate(['/requests-analysis/requests-table']);
        }
      );
  
  
  }



  isSelected(relationCode: string): boolean {
    return this.selectedAccount.relationCode === relationCode;
  }

      clientSelected(e: Account) {
        
           
        this.userAccounts = localStorage.getItem("accList") 
        ? JSON.parse(localStorage.getItem("accList")!) as Account[] 
        : [];
        
            }
      fetchUserPortfolio(selectedAcc?) {
        if (selectedAcc) this.selectedAccount = selectedAcc;
    
        if (this.selectedAccount != null && this.selectedAccount.relationCode) {
          this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
            .subscribe((res) => {
              this.userPortfolio = res as ClientData;
            });
        }
      }
      onAccountChange(relationCode: string) {
        const selectedAcc = this.userAccounts.find(acc => acc.relationCode === relationCode);
        if (selectedAcc) {
          this.selectedAccount = selectedAcc; 
          this.fetchUserPortfolio(selectedAcc); 
        }
      }
      getAccountClass(accountType: string): string {
        switch (accountType) {
          case 'Basic':
            return 'Basic';
          case 'Margin':
            return 'Margin';
          case 'Fund':
            return 'Fund';
          case 'MarginCustion':
              return 'MarginCustion';
          case 'Minor':
                return 'Minor'; 
          case 'Other':
                return 'Other';
          default:
            return 'default';
        }
      }
        formatCashInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/,/g, ''); // remove commas first
  
    if (!isNaN(Number(value)) && value !== '') {
      const parts = value.split('.');
      parts[0] = Number(parts[0]).toLocaleString('en-US'); // format integer part
      input.value = parts.join('.');
    }
  
    // Update FormControl without commas if needed
    this.cashControl.setValue(input.value, { emitEvent: false });
  }

  public resetStepper(): void {
    this.stepper?.reset();
    // Reset variables
    this.selectedAccount = null;
    this.selectedCurrency = null;
    this.selectedBank = null;
    this.selectedBranch = null;
    this.depositMethod = null;
    this.cashAmount = null;
    this.Date = null;
    this.fileToUpload = null;
    this.uploadedFiles = [];
    this.cashControl?.reset();
  }

  ngonDestroy() {
  
    this.resetStepper(); 
  }


}